import React, { useEffect, useRef } from 'react';
import { aboutData } from '../mock';
import { Award, BookOpen, GraduationCap } from 'lucide-react';

const About = () => {
  const aboutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = aboutRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const getIcon = (type) => {
    switch (type) {
      case 'Education':
        return <GraduationCap size={24} />;
      case 'Management':
        return <Award size={24} />;
      case 'Research':
        return <BookOpen size={24} />;
      default:
        return <Award size={24} />;
    }
  };

  return (
    <section className="about-section" ref={aboutRef}>
      <div className="about-container">
        <h2 className="section-title-clean fade-in">About Me</h2>
        
        <div className="credentials-grid fade-in">
          {aboutData.credentials.map((cred, index) => (
            <div key={index} className="credential-badge">
              <div className="credential-icon">{getIcon(cred.type)}</div>
              <div className="credential-content">
                <h4>{cred.name}</h4>
                <p>{cred.type}</p>
              </div>
            </div>
          ))}
        </div>
        
        <p className="about-bio fade-in">{aboutData.bio}</p>
      </div>
    </section>
  );
};

export default About;